import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=a2041cba&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=ts&"
export * from "./Generic.vue?vue&type=script&lang=ts&"
import style0 from "./Generic.vue?vue&type=style&index=0&id=a2041cba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2041cba",
  null
  
)

export default component.exports